import PublicationListTableBody from "./components/PublicationListTableBody/PublicationListTableBody";
import PublicationListTableHead from "./components/PublicationListTableHead/PublicationListTableHead";
import * as S from "./PublicationListTable.style";

const PublicationListTable = () => {
  return (
    <S.ListTable>
      <PublicationListTableHead />
      <PublicationListTableBody />
    </S.ListTable>
  );
};

export default PublicationListTable;
